import { Tooltip } from 'antd';
import { useSlateStatic } from 'slate-react';
import { isValidMessage } from '@/scripts/utils/isValidMessage';
import type { ChatParams } from '@/contexts/chat/scripts/hooks/useChats/types';
import { type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { useChatContext } from '@/contexts/chat/context';
import classes from './index.module.scss';
import MentionIcon from './images/mention.svg?react';
import ToolsIcon from './images/tools.svg?react';
import FormatIcon from './images/format.svg?react';
import MoreIcon from './images/more.svg?react';
import SendIcon from './images/send.svg?react';
import ZoomIcon from './images/zoom.svg?react';
import Emoji from './components/emoji';
import Pictures from './components/pictures';
import ExpireTime from './components/expire-time';
import FilesUpload from './components/files-upload';
//import DownIcon from './images/down.svg?react';

export interface ChatInputProps {
  className?: ClassNames;
  chat: Chat;
  payload: string;
  onSend: () => void;
  updateChats: (chats: ChatParams[]) => Promise<void>;
}

export default function ChatInputExtend({
  className,
  chat,
  payload,
  onSend,
  updateChats,
}: ChatInputProps) {
  const {
    fileMessages: { getPickInfoEventHandlers },
  } = useChatContext();

  const editor = useSlateStatic();

  const eventHandlers = useMemo(
    () => getPickInfoEventHandlers(chat),
    [chat, getPickInfoEventHandlers]
  );

  const eventHandlers_image = useMemo(
    () => getPickInfoEventHandlers(chat, { accept: 'img' }),
    [chat, getPickInfoEventHandlers]
  );

  return (
    <div
      className={cls(classes.chatInputExtends, className)}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <ExpireTime chat={chat} updateChats={updateChats} />
      <Emoji
        onEmojiClick={(emoji) => {
          editor.insertText(emoji);
        }}
      />
      <MentionIcon
        onClick={() => {
          editor.insertText('@');
        }}
      ></MentionIcon>
      <Pictures onSelect={eventHandlers_image.click.onClick} />
      <FilesUpload selectFilesClick={eventHandlers.click.onClick} />
      <ToolsIcon></ToolsIcon>
      <FormatIcon></FormatIcon>
      <MoreIcon></MoreIcon>
      <ZoomIcon></ZoomIcon>
      <div className={classes.divider}></div>
      <Tooltip title="Enter">
        <div
          className={cls(classes.send, isValidMessage(payload) && classes.sendActive)}
          onClick={onSend}
        >
          <SendIcon />
        </div>
      </Tooltip>
      {/* <DownIcon></DownIcon> */}
    </div>
  );
}
